<template>
    <v-container fluid style="padding: 0">
        <v-jumbotron id="jumbo" class="text-xs-center" :style="{ backgroundImage: 'url(' + require('@/assets/img/panoramica.jpg') + ')' }">
            <div class="overlay"></div>
            <v-container fill-height style="z-index:1;position: relative;">
                <v-layout align-center>
                    <v-flex class="white--text">
                        <h3 class="display-3 font-weight-medium">Calculador Solar</h3>
                        <v-divider class="my-3"></v-divider>
                        <v-flex md8 offset-md2 class="title font-weight-light">
                            Calcule cuánto ahorraría en su factura de electricidad colocando paneles solares en su hogar o empresa
                        </v-flex>
                    </v-flex>
                </v-layout>
            </v-container>
        </v-jumbotron>
        <v-container>
            <v-layout row wrap>
                <v-flex xs12 md8 offset-md2 class="text-xs-center">
                    <p>En pocos pasos podrá estimar lo que puede generar y ahorrar anualmente si instala paneles solares conectados a la red, conforme la
                        <strong>Ley Nacional de Generación Distribuida</strong>, N° 27.424. </p>
                    <p class="headline" style="margin: 30px 0">
                        <strong>
                            <v-icon>pan_tool</v-icon> Tenga a mano su factura de electricidad.
                        </strong>
                    </p>
                    <v-chip color="light-blue accent-1" class="mb-3">
                        <div></div>
                        <v-icon>help</v-icon> Clic en estos íconos para mayor información.
                    </v-chip>
                </v-flex>
                <v-flex xs12>
                    <v-alert type="warning" :value="true">
                        <h4>Atención</h4>
                        <p>Los resultados de este Calculador Solar son valores de referencia estimados cuya finalidad es orientar e informar al interesado. Para mayor precisión, se recomienda asesoramiento profesional a medida de su solicitud.</p>
                    </v-alert>
                </v-flex>
                <v-flex xs12 class="text-xs-center mt-4">
                    <v-btn to='/calculador' large color="success">Ir al Calculador</v-btn>
                </v-flex>
            </v-layout>
        </v-container>
    </v-container>
</template>

<script>
export default {
  name: 'Home'
}
</script>

<style scoped>
#jumbo {
  background-position: center center;
  background-size: cover;
}
.overlay {
  position: absolute;
  top: 0;
  left: 0;
  background: rgba(0, 0, 0, 0.5);
  height: 100%;
  width: 100%;
  z-index: 1;
}
</style>
